import dayjs from "dayjs";

export function formatDate(date) {
  // Example: 
  // INCOMING DATE Fri Sep 08 2023 09:49:05 GMT-0400 (Eastern Daylight Time)
  // OUTGOING DATE 9:49:5AM Friday, 9-8-2023

  return dayjs(date).format('H:mm:ss A dddd, M-D-YYYY')
}

export function truncateToTwoDecimals(num) {
  return Math.round(num * 100) / 100;
}